module.exports = __webpack_public_path__ + "img/volunteer-thankyou-banner.043321ef.png";